import { Caption1 } from "@fluentui/react-components";
import { ErrorCircleFilled } from "@fluentui/react-icons";
import { useTranslations } from "next-intl";
import { FC } from "react";

export interface FormErrorTextProps {
  success?: boolean;
  text?: string;
}

const FormErrorText: FC<FormErrorTextProps> = ({ success, text }) => {
  const t = useTranslations();
  return (
    <div className={`flex items-center text-red-700 my-[4px]`}>
      {text && !success && text.startsWith("error.server") ? (
        <>
          <div className="flex items-center justify-center mx-1">
            <ErrorCircleFilled />
          </div>
          <Caption1>{t(text)}</Caption1>
        </>
      ) : (
        <Caption1 className="invisible">placeholder</Caption1>
      )}
    </div>
  );
};

export default FormErrorText;
